import React from 'react';
import { MicIcon, BookOpenIcon, AwardIcon } from 'lucide-react';
import { speakingEngagements, publications, honors } from '../../data/careerTrackRecord';
export function CareerRecordColumns() {
  return <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-8" data-id="element-101" data-mp="9hnndud7j1dh">
      <div data-id="element-102" data-mp="dj8ypba3f7lk">
        <div className="flex items-center gap-2.5" data-id="element-103" data-mp="dk0kjudw1qyn">
          <MicIcon className="h-5 w-5 text-brandgreen" aria-hidden="true" data-id="element-104" data-mp="dktqit50wcfq" />
          <h3 className="font-heading text-base font-semibold text-navy" data-id="element-105" data-mp="ihsndjg2mxhm">Speaking Engagements</h3>
        </div>
        <ul className="mt-6 space-y-5 border-l border-slate-200 pl-5" data-id="element-106" data-mp="ng3wfryjl3ys">
          {speakingEngagements.map(item => <li key={item.role + item.event} className="relative" data-id="element-107" data-mp="sahtrzwrll63">
              <span className="absolute -left-[23px] top-1.5 h-2 w-2 rounded-full bg-brandgreen" aria-hidden="true" data-id="element-108" data-mp="x66onpxuadw2" />
              <p className="font-semibold text-navy" data-id="element-109" data-mp="11awh14tahac8">{item.role}</p>
              <p className="text-sm text-charcoal" data-id="element-110" data-mp="1697r9gnhxmuz">{item.event}</p>
              {item.detail && <p className="mt-1 text-sm italic text-slate-500" data-id="element-111" data-mp="1qsenawn4pb4b">{item.detail}</p>}
            </li>)}
        </ul>
      </div>

      <div data-id="element-112" data-mp="1moqd067441fd">
        <div className="flex items-center gap-2.5" data-id="element-113" data-mp="1mp03rvzzecm4">
          <BookOpenIcon className="h-5 w-5 text-brandgreen" aria-hidden="true" data-id="element-114" data-mp="1hqf2dt8ztmw3" />
          <h3 className="font-heading text-base font-semibold text-navy" data-id="element-115" data-mp="1csdij63qtjjk">Publications</h3>
        </div>
        <ul className="mt-6 space-y-5 border-l border-slate-200 pl-5" data-id="element-116" data-mp="2afmbfm62puvl">
          {publications.map(item => <li key={item.title} className="relative" data-id="element-117" data-mp="25gj57yecxim1">
              <span className="absolute -left-[23px] top-1.5 h-2 w-2 rounded-full bg-navy" aria-hidden="true" data-id="element-118" data-mp="25ivuyxqcwx9n" />
              <p className="font-semibold text-navy" data-id="element-119" data-mp="1vqzlkqitlkq4">{item.title}</p>
              <p className="text-sm text-charcoal" data-id="element-120" data-mp="1vqpu0yi4n5ib">{item.outlet}</p>
            </li>)}
        </ul>
      </div>

      <div data-id="element-121" data-mp="2t86pvyl0zxfv">
        <div className="flex items-center gap-2.5" data-id="element-122" data-mp="2ofne975wfcdp">
          <AwardIcon className="h-5 w-5 text-brandgreen" aria-hidden="true" data-id="element-123" data-mp="2oevi9v8e3cmw" />
          <h3 className="font-heading text-base font-semibold text-navy" data-id="element-124" data-mp="mhv2rcgrjc75">Industry Honors</h3>
        </div>
        <ul className="mt-6 space-y-5 border-l border-slate-200 pl-5" data-id="element-125" data-mp="qinau2dwfb1u">
          {honors.map(item => <li key={item.title} className="relative" data-id="element-126" data-mp="crih1gx7pczf">
              <span className="absolute -left-[23px] top-1.5 h-2 w-2 rounded-full bg-navy" aria-hidden="true" data-id="element-127" data-mp="hrej3amcmucc" />
              <p className="font-semibold text-navy" data-id="element-128" data-mp="2tm9ez3hh062">{item.title}</p>
              {item.detail && <p className="mt-1 text-sm leading-relaxed text-slate-500" data-id="element-129" data-mp="7t74uzjg2qe1">{item.detail}</p>}
            </li>)}
        </ul>
      </div>
    </div>;
}